<div *ngIf="parentFormGroup" [formGroup]="parentFormGroup" class="{{ field.cssClass }}">
    <h3 *ngIf="field.header">{{ field.header }}</h3>
    <p *ngIf="field.description" class="field-description">{{ field.description }}</p>

    <div class="block-editor">
        <div>
            <!-- Binds precomputed `rows`, never method calls: a method in a binding re-runs on
                 every change-detection cycle. -->
            <ion-reorder-group [disabled]="false" (ionItemReorder)="doReorder($any($event))">
                <ion-item
                    *ngFor="let row of rows; trackBy: trackByIndex"
                    class="block-row"
                    [class.selected]="selectedIndex === row.index"
                    [class.is-hidden]="row.hidden"
                    (click)="select(row.index)"
                >
                    <ion-reorder slot="start"></ion-reorder>
                    <ion-label>{{ row.label }}</ion-label>
                    <ion-icon *ngIf="row.hidden" name="eye-off-outline" slot="end"></ion-icon>
                </ion-item>
            </ion-reorder-group>

            <ion-item lines="none">
                <ion-select placeholder="Add {{ field.itemName || 'block' }}" (ionChange)="addBlock($any($event).detail.value)">
                    <ion-select-option *ngFor="let t of field.blockTypes" [value]="t.value">{{ t.label }}</ion-select-option>
                </ion-select>
            </ion-item>
        </div>

        <!-- Iterates a zero-or-one element list rather than using `*ngIf`, so that moving the
             selection DESTROYS this subtree and builds a new one.

             Reusing it silently binds the editor to the wrong block. `formGroupName` registers with
             its parent form in ngOnInit and implements no ngOnChanges, and the entries in
             `selectedFields` are shared object references from the form config (every block type
             draws its `width`/`hidden`/`breakBefore` from the same `commonFields` array), so ngFor
             sees identical items and reuses the views. Nothing underneath is re-initialised, and
             every `formControlName` stays bound to the control instances of whichever block was
             open when the views were first created. `editorKey` changes on every selection change
             AND on a type change — a type change calls `setControl`, which replaces the group at
             the same index, so tracking the index alone would not be enough. -->
        <div *ngFor="let key of editorKey; trackBy: trackBySelf" [formArrayName]="field.name">
            <div [formGroupName]="selectedIndex">
                <ion-item lines="full">
                    <ion-select label="Type" [value]="selectedType" (ionChange)="changeBlockType(selectedIndex, $any($event).detail.value)">
                        <ion-select-option *ngFor="let t of field.blockTypes" [value]="t.value">{{ t.label }}</ion-select-option>
                    </ion-select>
                </ion-item>

                <abs-universal-field
                    *ngFor="let itemField of selectedFields"
                    [field]="itemField"
                    [formValue]="formValue"
                ></abs-universal-field>

                <ion-item lines="none">
                    <ion-button color="danger" slot="start" (click)="deleteBlock(selectedIndex)">Delete</ion-button>
                    <ion-button color="warning" slot="start" (click)="duplicateBlock(selectedIndex)">Duplicate</ion-button>
                    <ion-button fill="outline" slot="end" (click)="select(selectedIndex)">Close</ion-button>
                </ion-item>
            </div>
        </div>

        <!-- `preview` is recomputed on selection and on a 200ms debounce of the form value, not
             produced by a method call in this binding. -->
        <div class="preview" *ngIf="selectedIndex !== null" [innerHTML]="preview"></div>
    </div>
</div>
